import { render, staticRenderFns } from "./LogActivity.vue?vue&type=template&id=8799c6c4"
import script from "./LogActivity.vue?vue&type=script&lang=js"
export * from "./LogActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports